import { Text, View } from 'react-native';

export default function Security() {
  return (
    <View>
      <Text>Security</Text>
    </View>
  );
}
